// Minimal adapter so components can read user/profile safely.
// Swap this later with your real store.

import { useEffect, useSyncExternalStore } from "react";

// simple in-memory snapshot (can be hydrated from your session/profile fetch)
const state = {
  user: null,
  profile: null,
};

// expose a setter you can call from your auth bootstrap
export function __setAuth(authLike) {
  state.user = authLike?.user ?? null;
  state.profile = authLike?.profile ?? null;
  emit();
}

// subscribe/emit for useSyncExternalStore
let listeners = new Set();
function subscribe(cb) { listeners.add(cb); return () => listeners.delete(cb); }
function emit() { for (const cb of listeners) cb(); }

export function useAuth() {
  return useSyncExternalStore(
    subscribe,
    () => state,
    () => state
  );
}

// If you already have session info on window, hydrate once:
if (typeof window !== "undefined" && window.__afrimed_auth) {
  __setAuth(window.__afrimed_auth);
}